import React from 'react';
import logo from './logo.svg';
import './App.css';
import ScoreTable from './ScoreTable';

function App() {
  return (
    <div className="App">
      <ScoreTable />
    </div>
  );
}

export default App;
